import { useEffect, useMemo } from 'react'
import Loading from 'components/loading/Loading'
import { useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import NumberFormat from 'react-number-format'
import {
  fetchDashboardInfoTotalCampaign,
  setTab,
} from 'features/dashboard/info/dashboardInfoSlice'
import { DashboardInfoTypes } from 'features/Codes'
import { isNullOrUndefined } from 'utils'
import WalletSpend from 'features/dashboard/info/WalletSpend'

const TotalCampaignInfo = () => {
  const dispatch = useDispatch()
  const {
    info: {
      isLoading,
      tabs,
      totalCampaign: { operation },
      totalError,
    },
    common: { from, to },
    filter: { filters },
  } = useSelector(state => state.dashboard)
  const type = DashboardInfoTypes.TOTAL_CAMPAIGN
  const tabName = useMemo(() => tabs[type], [tabs, type])

  useEffect(() => {
    if (
      !isLoading &&
      tabName === 'operationInfoTab' &&
      totalError === undefined &&
      isNullOrUndefined(operation)
    ) {
      dispatch(fetchDashboardInfoTotalCampaign())
    }
  }, [dispatch, tabName, isLoading, operation, totalError])

  useEffect(() => {
    dispatch(fetchDashboardInfoTotalCampaign())
  }, [dispatch, filters, from, to])

  useEffect(
    () => () => {
      dispatch(
        setTab({
          type,
          value: 'priceInfoTab',
        })
      )
    },
    [dispatch, type]
  )

  return isLoading ? (
    <div style={{ height: 368 }}>
      <Loading />
    </div>
  ) : (
    <>
      <strong className="screen_out">정보보기 탭</strong>
      <ul className="tab_g6">
        <li className={tabName === 'priceInfoTab' ? 'on' : ''}>
          <NoneAnchor
            className="link_tab"
            onClick={() =>
              dispatch(
                setTab({
                  type,
                  value: 'priceInfoTab',
                })
              )
            }>
            비용 정보
          </NoneAnchor>
        </li>
        <li className={tabName === 'operationInfoTab' ? 'on' : ''}>
          <NoneAnchor
            className="link_tab"
            onClick={() =>
              dispatch(
                setTab({
                  type,
                  value: 'operationInfoTab',
                })
              )
            }>
            운영 정보
          </NoneAnchor>
        </li>
      </ul>
      {tabName === 'priceInfoTab' && <WalletSpend />}
      {tabName === 'operationInfoTab' && operation && (
        <div className="tab_cont">
          <h4 className="screen_out">운영 정보</h4>
          <div className="infosum_dash">
            <table className="tbl_infosum">
              <caption className="hide_caption">
                운영 정보 데이터 테이블
              </caption>
              <colgroup>
                <col />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <div className="inner_cell">캠페인</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      운영가능{' '}
                      <NumberFormat
                        value={operation.inOperationCampaignCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      운영불가{' '}
                      <NumberFormat
                        value={operation.notInOperationCampaignCount}
                        displayType="text"
                        thousandSeparator
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div className="inner_cell">광고그룹</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      운영가능{' '}
                      <NumberFormat
                        value={operation.inOperationAdGroupCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      운영불가{' '}
                      <NumberFormat
                        value={operation.notInOperationAdGroupCount}
                        displayType="text"
                        thousandSeparator
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div className="inner_cell">키워드</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      심사승인{' '}
                      <NumberFormat
                        value={operation.approvedKeywordCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      심사중{' '}
                      <NumberFormat
                        value={operation.approvingKeywordCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      심사보류{' '}
                      <NumberFormat
                        value={operation.rejectedApprovalKeywordCount}
                        displayType="text"
                        thousandSeparator
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div className="inner_cell">소재</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      심사승인{' '}
                      <NumberFormat
                        value={operation.approvedCreativeCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      심사중{' '}
                      <NumberFormat
                        value={operation.approvingCreativeCount}
                        displayType="text"
                        thousandSeparator
                      />
                      <br />
                      심사보류{' '}
                      <NumberFormat
                        value={operation.rejectedApprovalCreativeCount}
                        displayType="text"
                        thousandSeparator
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}

export default TotalCampaignInfo
